const BackgroundGradients = () => {
    return (
        <>
            <div className="hidden md:block absolute top-1/4 -left-20 w-96 h-96 bg-primary/20 rounded-full blur-[100px] animate-pulse-slow"></div>
            <div className="hidden md:block absolute bottom-1/4 -right-20 w-96 h-96 bg-teal-500/20 rounded-full blur-[100px] animate-pulse-slow delay-1000"></div>
        </>
    );
};

export default BackgroundGradients;
